import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';

import { ImageMode } from '@p1/libs/file';


@Component({
  selector: 'p1-lib-ui-elements-image-tile',
  templateUrl: './image-tile.component.html',
  styleUrls: ['./image-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageTileComponent {

  @Input()
  name: string;

  @Input()
  link: string | string[];

  @Input()
  openInNewTab: boolean = false;

  @Input()
  gtmEventCategory: string;

  @Input()
  gtmEventAction: string;

  @Input()
  gtmEventLabel: string;

  @Input()
  ad: boolean;

  @Input()
  imageUuid: string;

  @Input()
  fullWidth: boolean = false;

  imageMode = ImageMode;

  get nameNlToBr(): string {
    return this.name ? this.name.replace(/(?:\r\n|\r|\n)/g, '<br>') : null;
  }

  get nameStrippedNl(): string {
    return this.name ? this.name.replace(/(?:\r\n|\r|\n)/g, ' ') : null;
  }

  constructor() {}

  /**
   * returns wether the link is an internal or external source
   * CategoryTiles routes to an internal route, the template uses [routerLink]
   * LinkTiles routes to an external route, the template uses [href]
   * The template distinguishes between isExternalLink and !isExternalLink to print the correct link
   *
   * @param link
   * @returns boolean
   */
  isExternalLink(link): boolean {
    if (!link) {
      return null;
    }

    return !Array.isArray(link) && ((link.startsWith('https://') || link.startsWith('http://')));
  }
}
